import { ReactNode, useEffect, useState } from 'react'
import type { Transport } from 'viem'
import { WagmiProvider, createConfig, http, webSocket } from 'wagmi'
import { Chain, hardhat, mainnet } from 'wagmi/chains'
import { injected, walletConnect } from 'wagmi/connectors'

const projectId = 'ca20cea8cd8781a083b8ed33075f0688'

const blockPotTestnet: Chain = {
    id: 69696,
    nativeCurrency: {
        symbol: 'ETH',
        name: 'Ethereum',
        decimals: 18
    },
    name: 'BlockPot Testnet',
    rpcUrls: {
        default: {
            http: ['https://testnet.blockpot.com'],
            webSocket: ['wss://testnet.blockpot.com']
        },
        public: {
            http: ['https://testnet.blockpot.com'],
            webSocket: ['wss://testnet.blockpot.com']
        }
    }
}

const metadata = {
    name: 'BlockPot',
    description: 'The people\'s lottery',
    url: 'https://blockpot.com',
    icons: ['https://avatars.githubusercontent.com/u/37784886'] // TODO: Change me
}

const appMode = import.meta.env.VITE_APP_MODE
console.log('appMode', appMode)

export const chains = appMode === 'STAGING' 
    ? [blockPotTestnet, mainnet] as const
    : [hardhat] as const

const transports: Record<number, Transport> = appMode === 'STAGING'
    ? {
        [blockPotTestnet.id]: webSocket(),
        [mainnet.id]: http()
    }
    : {
        [hardhat.id]: webSocket('ws://localhost:8545', { reconnect: true })
    }

const wagmiConfig = createConfig({
    chains,
    transports,
    connectors: [
        walletConnect({ projectId, metadata, showQrModal: false }),
        injected({ shimDisconnect: true }),
    ],
})

export type Web3ProviderProps = {
    children: ReactNode
}

export default function Web3Provider(props: Web3ProviderProps) {
    const [mounted, setMounted] = useState(false)

    useEffect(() => {
        setMounted(true)
    }, [])

    return (
        <WagmiProvider config={wagmiConfig}>
            {mounted && props.children}
        </WagmiProvider>
    )
}